<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-sys__userpushreport}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <!-- <el-form-item>
          <el-input v-model="dataForm.id" placeholder="id" clearable></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-select v-model="dataForm.productId" filterable clearable placeholder="产品名称">
            <el-option
                    v-for="(item,index) in productList"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getTimes"
            value-format="yyyy-MM-dd"
            align="right">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:userpushreport:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:userpushreport:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item> -->
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <!-- <el-table-column type="selection" header-align="center" align="center" width="50" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="id" label="id" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="currentData" label="日期" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="companyName" label="公司名称" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productName" label="产品名称" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="productDockingMethod" label="产品对接方式" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ getDictLabel(scope.row.productDockingMethod) }}
          </template>
        </el-table-column>
        <el-table-column prop="returnStatus" label="协议确认" header-align="center" align="center" >
          <template slot-scope="scope">
	           <span v-if="scope.row.returnStatus == 1">进件返</span>
             <span v-if="scope.row.returnStatus == 2">撞库返</span>
             <span v-if="scope.row.returnStatus == 3">全流程返</span>
        	</template>
        </el-table-column>
        <el-table-column prop="mark" label="是否掩码" header-align="center" align="center">
          <template slot-scope="scope">
	           <span v-if="scope.row.mark == 1">掩码</span>
             <span v-if="scope.row.mark == 0">非掩码</span>
        	</template>
        </el-table-column>
        <el-table-column prop="settlementMethod" label="产品结算方式" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.row.settlementMethod == '0'">固价</div>
            <div v-if="scope.row.settlementMethod == '1'">分润前</div>
            <div v-if="scope.row.settlementMethod == '2'">分润后</div>
          </template>
        </el-table-column>
        <el-table-column prop="pushNum" label="数量" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ratio" label="分润比例" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="totalPrice" label="产品结算价格/分润总价" header-align="center" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.settlementMethod== '0' ? scope.row.productPrice : scope.row.totalPrice }}
          </template>
        </el-table-column>
        <el-table-column prop="totalSettlementAmount" label="结算总价" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="creator" label="创建者" header-align="center" align="center" show-overflow-tooltip></el-table-column> -->
        <el-table-column prop="createDate" label="创建时间" header-align="center" align="center" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="updater" label="更新者" header-align="center" align="center" show-overflow-tooltip></el-table-column> -->
        <!-- <el-table-column prop="updateDate" label="更新时间" header-align="center" align="center" show-overflow-tooltip></el-table-column> -->
        <!-- <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:userpushreport:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:userpushreport:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './userpushreport-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/sys/userpushreport/page',
        getDataListIsPage: true,
        exportURL: '/sys/userpushreport/export',
        deleteURL: '/sys/userpushreport',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      },
      productMethodList:[],
      productList:[],
      dateValue: '',
      pickerOptions: {
          shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
            
          {
            text: '昨天',
            onClick(picker) {
              console.log(picker)
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '过去七天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: "上周",
            onClick(picker) {
              // 上周开始时间
              const starta = new Date();
              var first = starta.getDate() - starta.getDay() - 6;
              var startDate = new Date(starta.setDate(first));
              const start = new Date(startDate);
              start.setHours(0, 0, 0, 0);
              //  上周结束时间
              var currentDate = new Date();
              var firsts = currentDate.getDate() - currentDate.getDay() - 6;
              var last = firsts + 6;
              var endDate = new Date(currentDate.setDate(last));
              const end = new Date(endDate);
              end.setHours(23, 59, 59, 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              var end = new Date();
              var week = end.getDay();
              console.log(week,'week')
              //一天的毫秒数
              var millisecond = 1000 * 60 * 60 * 24;
              //减去的天数
              var minusDay = week != 0 ? week - 1 : 6;
              
              //本周 周一
              var monday = new Date(end.getTime() - minusDay * millisecond);
              const start = new Date(monday);
              start.setHours(0, 0, 0, 0);
              console.log("2312", start, end);
              picker.$emit("pick", [start, end]);
            },

          },
       ]
        },
    }
  },
  components: {
    AddOrUpdate
  },
  created () {
    this.getProductMethods()
    this.getProductList()
  },
  methods: {
    getTimes() {
        if (this.dateValue != null) {
          this.dataForm.startDate = this.dateValue[0]
          this.dataForm.endDate = this.dateValue[1]
        }else{
          delete this.dataForm.startDate 
        delete this.dataForm.endDate
        }
      },
    getDictLabel(value) {
      const dictItem = this.productMethodList.find(item => item.value === value);
      return dictItem ? dictItem.label : ''; // 返回对应的 label 或空字符串
    },
    //初始化产品对接方式
    async getProductMethods() {
      this.$http.get(`/sys/dict/data/list?dataType=productDockingMethod`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data!=null){
          res.data.forEach(element => {
            this.productMethodList.push({label:element.dictLabel,value:element.dictValue})
          })
        }
      }).catch(() => {})
    },
    // 产品名称列表
    async getProductList() {
      this.$http.get(`sys/slproduct/page?order=&orderField=&page=1&limit=500`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        if (res.data!=null){
          res.data.list.forEach(element => {
            this.productList.push({label:element.productName,value:element.id})
          })
        }
      }).catch(() => {})
    }
  }
}
</script>
